// import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
//import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
//import { msalConfig } from "./authConfig.js";
import authentication from './B2CAuth';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { AdminProvider } from './contexts/AdminContext';
import { CheckinProvider } from './contexts/CheckinContext';


authentication.initialize({
  instance: 'https://statussolutionsmimi.b2clogin.com/tfp/',
  tenant: 'StatusSolutionsMIMI.onmicrosoft.com',
  signInPolicy: 'B2C_1_SignIn',
  resetPolicy: 'B2C_1_PasswordReset',
  applicationId: '6b5a6f5c-9fe3-4d13-95a4-e61dd348c88e',
  cacheLocation: 'sessionStorage',
  redirectUri: 'https://' + window.location.hostname + ':' + window.location.port,
  scopes: ['https://StatusSolutionsMIMI.onmicrosoft.com/admin/user_impersonation'],
  postLogoutRedirectUri: 'https://' + window.location.hostname + ':' + window.location.port + '/',
  validateAuthority: false,
  storeAuthStateInCookie: true
});


//const msalInstance = new PublicClientApplication(msalConfig);

//// Default to using the first account if no account is active on page load
//if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//    // Account selection logic is app dependent. Adjust as needed for different use cases.
//    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
//}

//msalInstance.addEventCallback((event) => {
//    if (
//        (event.eventType === EventType.LOGIN_SUCCESS ||
//            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
//            event.eventType === EventType.SSO_SILENT_SUCCESS) &&
//        event.payload.account
//    ) {
//        msalInstance.setActiveAccount(event.payload.account);
//    }
//});
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

if (window === window.parent && !window.opener) {
  root.render(
  <BrowserRouter basename={baseUrl}>
      {/*<App instance={msalInstance} />*/}
      <EnvironmentProvider>
        <AdminProvider>
          <CheckinProvider>
            <App />
          </CheckinProvider>
        </AdminProvider>
      </EnvironmentProvider>
  </BrowserRouter>);

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    serviceWorkerRegistration.unregister();

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}
